import client from '@/lib/axios-client'
import type {
	CustomerInput,
	CustomerListOutput,
	CustomerListParams,
	CustomerOutput,
	UpdateCustomerBody,
} from '@/types/customer'

const CUSTOMERS_URL = '/customers'

// ── GET /customers ────────────────────────────────────────────────────────────

export async function getCustomers(
	params?: CustomerListParams,
): Promise<CustomerListOutput> {
	const response = await client.get(CUSTOMERS_URL, { params })
	return response.data.data
}

// ── GET /customers/:id ────────────────────────────────────────────────────────

export async function getCustomerById(id: string): Promise<CustomerOutput> {
	const response = await client.get(`${CUSTOMERS_URL}/${id}`)
	return response.data.data
}

// ── POST /customers ───────────────────────────────────────────────────────────

export async function createCustomer(
	body: CustomerInput,
): Promise<CustomerOutput> {
	const response = await client.post(CUSTOMERS_URL, body)
	return response.data.data
}

// ── PUT /customers/:id ──────────────────────────────────────────────────────

export async function updateCustomer(
	id: string,
	body: UpdateCustomerBody,
): Promise<CustomerOutput> {
	const response = await client.put(`${CUSTOMERS_URL}/${id}`, body)
	return response.data.data
}

// ── DELETE /customers/:id ─────────────────────────────────────────────────────

export async function deleteCustomer(id: string): Promise<void> {
	await client.delete(`${CUSTOMERS_URL}/${id}`)
}
